import { pqereignissemessstelle, pqstatus, pqstatusmessstelle, messwertLog } from './../../utils/apiTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { pqereignisseState } from './pqEreignisseTypes';
import { AppDispatch, RootState } from '../../app/store';
import { getWithAuth, postWithAuth } from '../../utils/api';
import { logError } from '../../utils/utils';
import { errorHandler } from '../../utils/errorHandling';

export const pqereignissemessstelleDummy: pqereignissemessstelle = {
    zeit: 0,
    ende: 0,
    messstelle: "",
    typ: "",
    phase: "",
    harmonische: "",
    beschreibung: "",
    zustand: 0
};

export const stoerstriebemessstelleDummy: messwertLog = {
    id: 0,
    triggerZeitpunkt: null,
    start: 0,
    ende: 0,
    messstelle: "",
    datenklasseId: 0,
    datenklasse: ""
};

const initialState: pqereignisseState = {
    pqstatus: [],
    pqmessstellenstatus: [],
    pqmessstellenereignisse: [],
    altesPQmessstellenereignis: pqereignissemessstelleDummy,
    aktuellesPQmessstellenereignis: pqereignissemessstelleDummy,
    pqmessstellenstoerschriebe: [],
    altesPQmessstellenstoerschrieb: stoerstriebemessstelleDummy,
    aktuellesPQmessstellenstoerschrieb: stoerstriebemessstelleDummy,
    editDirty: 0,
    pqstatusLoading: false,
    pqmessstellenstatusLoading: false,
    pqmessstellenereignisseLoading: false,
    pqmessstellenstoerschriebeLoading: false,
    zeitraum: "1M",
    messstellenFilter: [],
    ereignisseFilter: [],
    stoerschriebeFilter: [],
}

const pqEreignisseSlice = createSlice({
    name: "pqereignisse",
    initialState,
    reducers: {
        setPQStatus: (state, action: PayloadAction<Array<pqstatus>>) => {
            state.pqstatus = action.payload;
        },
        setPQMessstellenStatus: (state, action: PayloadAction<Array<pqstatusmessstelle>>) => {
            state.pqmessstellenstatus = action.payload;
        },
        setPQMessstellenEreignisse: (state, action: PayloadAction<Array<pqereignissemessstelle>>) => {
            state.pqmessstellenereignisse = action.payload;
        },
        addAktuellesMessgeraetToPQmessstellenEreignis: (state) => {
            const pqMesstelenereignisArray = state.pqmessstellenereignisse;
            pqMesstelenereignisArray.push(state.aktuellesPQmessstellenereignis);
            state.pqmessstellenereignisse = [...pqMesstelenereignisArray].sort((a, b) => a.typ.localeCompare(b.typ));
        },
        setAktuellesPQmessstellenereignis: (state, action: PayloadAction<pqereignissemessstelle>) => {
            state.aktuellesPQmessstellenereignis = action.payload;
            state.altesPQmessstellenereignis = action.payload;
        },
        setAltesPQmessstellenereignis: (state, action: PayloadAction<pqereignissemessstelle>) => {
            state.altesPQmessstellenereignis = action.payload;
        },
        resetAktuellesPQmessstellenereignis: (state) => {
            state.aktuellesPQmessstellenereignis = state.altesPQmessstellenereignis;
        },
        setPQMessstellenStoerschriebe: (state, action: PayloadAction<Array<messwertLog>>) => {
            state.pqmessstellenstoerschriebe = action.payload;
        },
        addToPQMessstellenStoerschriebe: (state, action: PayloadAction<Array<messwertLog>>) => {
            state.pqmessstellenstoerschriebe = [...state.pqmessstellenstoerschriebe, ...action.payload].sort((a, b) => b.ende - a.ende);
        },
        setAktuellesPQmessstellenStoerschrieb: (state, action: PayloadAction<messwertLog>) => {
            state.aktuellesPQmessstellenstoerschrieb = action.payload;
            state.altesPQmessstellenstoerschrieb = action.payload;
        },
        setAltesPQmessstellenStoerschrieb: (state, action: PayloadAction<messwertLog>) => {
            state.altesPQmessstellenstoerschrieb = action.payload;
        },
        resetAktuellesPQmessstellenStoerschrieb: (state) => {
            state.aktuellesPQmessstellenstoerschrieb = state.altesPQmessstellenstoerschrieb;
        },
        setPQStatusLoading: (state, action: PayloadAction<boolean>) => {
            state.pqstatusLoading = action.payload;
        },
        setPQmessstellenstatusLoading: (state, action: PayloadAction<boolean>) => {
            state.pqmessstellenstatusLoading = action.payload;
        },
        setPQmessstellenereignisseLoading: (state, action: PayloadAction<boolean>) => {
            state.pqmessstellenereignisseLoading = action.payload;
        },
        setPQmessstellenstoerschriebeLoading: (state, action: PayloadAction<boolean>) => {
            state.pqmessstellenstoerschriebeLoading = action.payload;
        },
        setZeitraum: (state, action: PayloadAction<string>) => {
            state.zeitraum = action.payload;
        },
        setMessstellenFilter: (state, action: PayloadAction<Array<string>>) => {
            state.messstellenFilter = action.payload;
        },
        setEreignisseFilter: (state, action: PayloadAction<Array<string>>) => {
            state.ereignisseFilter = action.payload;
        },
        setStoerschriebeFilter: (state, action: PayloadAction<Array<string>>) => {
            state.stoerschriebeFilter = action.payload;
        },
        setTyp: (state, action: PayloadAction<string>) => {
            state.aktuellesPQmessstellenereignis.typ = action.payload;
            state.editDirty =
                state.aktuellesPQmessstellenereignis.typ ==
                    state.altesPQmessstellenereignis.typ
                    ? state.editDirty - 1
                    : state.editDirty + 1;
        },
        setDatenklasse: (state, action: PayloadAction<string>) => {
            state.aktuellesPQmessstellenstoerschrieb.datenklasse = action.payload;
            state.editDirty =
                state.aktuellesPQmessstellenstoerschrieb.datenklasse ==
                    state.altesPQmessstellenstoerschrieb.datenklasse
                    ? state.editDirty - 1
                    : state.editDirty + 1;
        },
        setDatenklasseID: (state, action: PayloadAction<number>) => {
            state.aktuellesPQmessstellenstoerschrieb.datenklasseId = action.payload;
            state.editDirty =
                state.aktuellesPQmessstellenstoerschrieb.datenklasseId ==
                    state.altesPQmessstellenstoerschrieb.datenklasseId
                    ? state.editDirty - 1
                    : state.editDirty + 1;
        },
        resetEditDirty: (state) => {
            state.editDirty = 0;
        },
    }
});

export const {
    setPQMessstellenStoerschriebe,
    setPQStatus,
    setPQMessstellenStatus,
    setPQMessstellenEreignisse,
    setTyp,
    setDatenklasse,
    setPQStatusLoading,
    setPQmessstellenstatusLoading,
    setPQmessstellenereignisseLoading,
    setPQmessstellenstoerschriebeLoading,
    setZeitraum,
    setMessstellenFilter,
    setEreignisseFilter,
    setStoerschriebeFilter,
    addToPQMessstellenStoerschriebe
} = pqEreignisseSlice.actions

export const selectPQStatus = (state: RootState): Array<pqstatus> =>
    state.pqereignisse.pqstatus;
export const selectPQMessstellenStatus = (state: RootState): Array<pqstatusmessstelle> =>
    state.pqereignisse.pqmessstellenstatus;
export const selectPQMessstellenEreignisse = (state: RootState): Array<pqereignissemessstelle> =>
    state.pqereignisse.pqmessstellenereignisse;
export const selectAktuellesPQMessstellenEreignis = (state: RootState): pqereignissemessstelle =>
    state.pqereignisse.aktuellesPQmessstellenereignis;
export const selectPQMessstellenStoerschriebe = (state: RootState): Array<messwertLog> =>
    state.pqereignisse.pqmessstellenstoerschriebe;
export const selectAktuellesPQmessstellenStoerschrieb = (state: RootState): messwertLog =>
    state.pqereignisse.aktuellesPQmessstellenstoerschrieb;
export const selectPQStatusLoading = (state: RootState): boolean =>
    state.pqereignisse.pqstatusLoading;
export const selectPQmessstellenstatusLoading = (state: RootState): boolean =>
    state.pqereignisse.pqmessstellenstatusLoading;
export const selectPQmessstellenereignisseLoading = (state: RootState): boolean =>
    state.pqereignisse.pqmessstellenereignisseLoading;
export const selectStoerschriebeereignisseLoading = (state: RootState): boolean =>
    state.pqereignisse.pqmessstellenstoerschriebeLoading;
export const selectZeitraum = (state: RootState): string => state.pqereignisse.zeitraum;
export const selectMessstellenFilter = (state: RootState): Array<string> => state.pqereignisse.messstellenFilter;
export const selectEreignisseFilter = (state: RootState): Array<string> => state.pqereignisse.ereignisseFilter;

export const selectStoerschreibeFilter = (state: RootState): Array<string> => state.pqereignisse.stoerschriebeFilter;

export const getPQStatus = () => (dispatch: AppDispatch): void => {
    dispatch(setPQStatusLoading(true));
    getWithAuth("PQSTATUS", {})
        .then((status: Array<pqstatus>) => dispatch(setPQStatus(status)))
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        })
        .finally(() => dispatch(setPQStatusLoading(false)));

    dispatch(setPQmessstellenstatusLoading(true));
    getWithAuth("PQSTATUSMESSSTELLE", {})
        .then((statusmessstellen: Array<pqstatusmessstelle>) => dispatch(setPQMessstellenStatus(statusmessstellen)))
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        })
        .finally(() => dispatch(setPQmessstellenstatusLoading(false)));

}

export const getPQEreignisseForMessstelle = (messstelle: pqstatusmessstelle, zeitraum: string) => (dispatch: AppDispatch): void => {
    const now = new Date();
    const from = new Date();
    switch (zeitraum) {
        case "24h":
            from.setHours(now.getHours() - 24);
            break;
        case "1M":
            from.setMonth(now.getMonth() - 1);
            break;
        case "12M":
            from.setFullYear(now.getFullYear() - 1);
            break;
    }
    dispatch(setPQmessstellenereignisseLoading(true));
    getWithAuth("PQEREIGNIS", { from: from.toISOString(), to: now.toISOString(), messstelle: messstelle.messstelle })
        .then((ereignisse: Array<pqereignissemessstelle>) => dispatch(setPQMessstellenEreignisse(ereignisse)))
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        })
        .finally(() => dispatch(setPQmessstellenereignisseLoading(false)));
}
export const getMesswertuebersicht = (messstelle: pqstatusmessstelle, zeitraum: string) => (dispatch: AppDispatch): void => {
    const now = new Date();
    const from = new Date();
    switch (zeitraum) {
        case "24h":
            from.setHours(now.getHours() - 24);
            break;
        case "1M":
            from.setMonth(now.getMonth() - 1);
            break;
        case "12M":
            from.setFullYear(now.getFullYear() - 1);
            break;
    }
    dispatch(setPQmessstellenstoerschriebeLoading(true));
    postWithAuth("MESSWERTLOG",
        {
            hersteller: "Eberle",
            datenklasse: "crecb",
            from: from.toISOString(),
            to: now.toISOString(),
        },
        messstelle.messstelle)
        .then((stoerschriebe: Array<messwertLog>) => dispatch(setPQMessstellenStoerschriebe(stoerschriebe)))
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        });

    postWithAuth("MESSWERTLOG", {
        hersteller: "Eberle",
        datenklasse: "creca",
        from: from.toISOString(),
        to: now.toISOString(),
    }, messstelle.messstelle)
        .then((stoerschriebe: Array<messwertLog>) => dispatch(addToPQMessstellenStoerschriebe(stoerschriebe)))
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        })
        .finally(() => dispatch(setPQmessstellenstoerschriebeLoading(false)));

}
export default pqEreignisseSlice.reducer